module.exports = __webpack_public_path__ + "img/TG.5c56ca02.svg";